export const blockIconsTravelEscalatorWarningNew = (
	<span className='material-symbols-outlined'>escalator_warning</span>
);
